import React from "react";
import {
  ActivityIndicator,
  Pressable,
  StyleSheet,
  TouchableNativeFeedback,
  TouchableOpacity,
  View,
} from "react-native";
import Checkbox from "@components/Checkbox";
import { Menu, MenuItem } from "react-native-material-menu";
import { connect } from "react-redux";
import DeleteIcon from "@assets/svg/DeleteIcon";
import SettingBlack from "@assets/svg/SettingBlack";
import Alert from "@assets/svg/WithdrawMoney/Alert";
import BankImage from "@assets/svg/WithdrawMoney/Bank";
import Plus from "@assets/svg/WithdrawMoney/Cross";
import NoBank from "@assets/svg/WithdrawMoney/NoBank";
import UPI from "@assets/svg/WithdrawMoney/UPI";
import Text from "@components/AppText";
import CustomText from "@components/CustomText";
import colors from "@constants/color";
import t from "@constants/localization";
import analytics from "@services/analytics";
import { scale, verticalScale } from "@utils/scale";
import InputBox from "../../components/InputBox";
import ModalLoader from "../../components/ModalLoader";
import { ACCOUNT_DELETED } from "../../constants/analyticsEvents";
import { OTHER_EVENTS } from "../../constants/analyticsEventsCT";
import { STATE_STATUS } from "../../reducers/actionTypes";
import { actions as walletActions } from "../../reducers/oldWalletReducer";
import {
  deleteFundAccount,
  getAllWalletMetaData,
  getWalletOtp,
  getWalletSummary,
  validateAmount,
} from "../../services/api";
import { ConfirmDelete } from "./ConfirmDelete";
import PaymentStatusModal from "./PaymentStatusModal";
import { TabButton } from "./TabButton";

const PATH = "screens/WithdrawMoney/Content";

const ACCOUNT_TYPE = {
  bank_account: "bank_account",
  vpa: "vpa",
};

const UPI_ID = Symbol("upi_id");

class WithdrawMoneyContent extends React.Component {
  state = {
    activeIndex: null,
    amount: {},
    amountError: {},
    amountLoading: false,
    upi: null,
    upiError: null,
    withdrawAllAmount: {},
    bankSelected: true,
    upiSelected: false,
    modalVisible: false,
    selectedItem: {},
    openMenuIndex: null,
  };

  reload = false;

  _menu = null;

  componentDidMount() {
    if (this.props.wallet.fundAccountStatus !== STATE_STATUS.FETCHED) {
      this.props.fetchFundAccounts();
    }
  }

  setMenuRef = (ref) => {
    this._menu = ref;
  };

  deleteAccount = (x) => {
    const payload = {
      edit: true,
      fund_account_id: x.id,
      account_type: "bank_account",
      ifsc: x.ifsc_code,
      account_number: x.account_number,
      name: x.user_name,
    };

    deleteFundAccount(payload)
      .then(async ({ data }) => {
        await analytics.trackEvent(ACCOUNT_DELETED, {
          method: this.props.upiSelected ? "upi" : "bank",
        });
        this.props.fetchFundAccounts();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  hideMenu = () => {
    this._menu.hide();
  };

  showMenu = () => {
    this._menu.show();
  };

  componentDidUpdate() {
    if (
      this.props.wallet.createFundAccountStatus === STATE_STATUS.CREATED &&
      this.reload === true
    ) {
      this.props.fetchFundAccounts();
      this.props.resetFundAccountBank();
      this.reload = false;
    }
  }

  setActiveIndex(val) {
    this.setState({
      activeIndex: val,
    });
  }

  checkValidAmount = async (amount) => {
    if (amount.trim()) {
      try {
        let { data } = await validateAmount(amount);
        setIfscDetails(data);
      } catch (e) {}
    } else {
      setIfscDetails(null);
    }
  };

  renderEnterAmountView = (x) => {
    const { getUpiId, upi, upiError } = x;
    const { amountError, amountLoading, withdrawAllAmount } = this.state;
    const { totals = {} } = this.props.wallet.walletSummary || {};
    const {
      user: { phone_number = "", id = "", name = "" },
    } = this.props || {};
    const total_balance = totals ? totals.balance : "0";

    return (
      <View style={styles.enter_amount_view}>
        <View
          style={{
            width: scale(296),
            marginBottom: verticalScale(16),
            alignSelf: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            height: 1,
          }}
        />
        {getUpiId && (
          <>
            <InputBox
              borderRadius={6}
              containerStyle={{
                flex: 1,
              }}
              placeholder={t(`${PATH}/example`)}
              value={this.state.upi}
              onChange={(upiID) => {
                this.setState({
                  upi: upiID,
                  upiError: null,
                });
              }}
              error={this.state.upiError !== null}
              // errorMessage={this.state.upiError}
              keyboardType="default"
              labelTextColor={colors.primary}
            />
            <Text
              mukta
              fontType="head4"
              style={{
                color: colors.silver,
                marginBottom: 18,
                marginTop: 4,
              }}
            >
              {t(`${PATH}/example`)} : phonenumber@upi
            </Text>
            {this.state.upiError && (
              <Text
                style={{
                  color: colors.internationalOrange,
                  marginBottom: 0,
                  position: "absolute",
                  right: 32,
                  top: 36,
                }}
                disabled={true}
                fontType="content2"
              >
                {this.state.upiError}
              </Text>
            )}
          </>
        )}
        <View
          style={{
            flexDirection: "row",
            marginBottom: 12,
          }}
        >
          <InputBox
            borderRadius={6}
            bold={true}
            containerStyle={{
              flex: 1,
              marginRight: 6,
            }}
            placeholder={t(`${PATH}/enterAmount`)}
            error={!!amountError[x.id]}
            // errorMessage={amountError[x.id]}
            value={this.state.amount[x.id]}
            onChange={(amount) => {
              this.setState({
                amount: {
                  ...this.state.amount,
                  [x.id]: amount,
                },
                amountError: {},
                withdrawAllAmount: {
                  ...this.state.withdrawAllAmount,
                  [x.id]: false,
                },
              });
            }}
            keyboardType="number-pad"
            labelTextColor={colors.primary}
          />
          <TouchableOpacity
            disabled={!this.state.amount[x.id]}
            onPress={async () => {
              if (getUpiId && !/^\w+@\w+$/.test(this.state.upi)) {
                // validate upi.
                this.setState({
                  upiError: t(`${PATH}/wrongUPI`),
                });
                return;
              }
              this.setState({
                amountLoading: true,
              });
              try {
                let { data } = await validateAmount(
                  this.state.amount[x.id],
                  x.default_mode,
                );
                if (data && data.errors && data.errors.length > 0) {
                  this.setState({
                    amountError: {
                      ...this.state.amountError,
                      [x.id]: data.errors[0].message,
                    },
                    amountLoading: false,
                  });

                  analytics.trackEvent(OTHER_EVENTS.MONEY_DEBITED, {
                    amount: this.state.amount[x.id],
                    method: x.default_mode,
                  });
                  return;
                }
              } catch (e) {
                let data = e.response && e.response.data;
                if (data && data.errors && data.errors.length > 0) {
                  this.setState({
                    amountError: {
                      ...this.state.amountError,
                      [x.id]: data.errors[0].message,
                    },
                    amountLoading: false,
                  });
                  return;
                }
              }
              this.setState({
                amountLoading: false,
              });

              if (getUpiId) {
                if (!this.state.upi) {
                  this.setState({
                    upiError: t(`${PATH}/enterAValidUPI`),
                  });
                  return;
                }
                this.props.createFundAccountVpa({
                  account_type: ACCOUNT_TYPE.vpa,
                  upi_address: this.state.upi,
                  amount: Number(this.state.amount[x.id]),
                });
                this.setState({
                  amount: {},
                  activeIndex: null,
                });
                this.reload = true;
                return;
              }
              this.props.withdrawMoney({
                fund_account_id: x.id,
                amount: this.state.amount[x.id],
                mode: x.default_mode,
              });
              this.setState({
                amount: {},
                activeIndex: null,
              });
              this.reload = true;
            }}
            style={[
              styles.enter_amount_button,
              {
                backgroundColor: !this.state.amount[x.id]
                  ? colors.silver
                  : colors.primary,
                alignSelf: "flex-start",
              },
            ]}
          >
            {this.state.amountLoading ? (
              <ActivityIndicator size="small" color={colors.white} />
            ) : (
              <Text bold mukta fontType="head3" style={{ color: colors.white }}>
                {t(`${PATH}/withdraw`)}
              </Text>
            )}
          </TouchableOpacity>
        </View>
        {amountError[x.id] && (
          <Text
            style={{ color: colors.internationalOrange, marginBottom: 8 }}
            disabled={true}
            fontType="content2"
          >
            {amountError[x.id]}
          </Text>
        )}
        <Checkbox
          label={t(`${PATH}/withdrawAllMoney`)}
          checked={withdrawAllAmount[x.id]}
          checkedImage={require("../../assets/svg/WithdrawMoney/BoxChecked.webp")}
          uncheckedImage={require("../../assets/svg/WithdrawMoney/BoxUnChecked.webp")}
          onChange={() => {
            this.setState({
              withdrawAllAmount: {
                ...this.state.withdrawAllAmount,
                [x.id]: !withdrawAllAmount[x.id],
              },
              amount: {
                ...this.state.amount,
                [x.id]: withdrawAllAmount[x.id] ? null : total_balance,
              },
            });
          }}
        />
      </View>
    );
  };

  renderBlackListedBanks = (x) => {
    const { is_blacklisted } = x;
    const {
      user: { phone_number = "", id = "", name = "" },
    } = this.props || {};

    if (is_blacklisted) {
      return (
        <View style={styles.black_listed_view}>
          <Alert />
          <Text
            mukta
            fontType="head4"
            style={{
              flex: 1,
              marginLeft: 8,
              color: colors.internationalOrange,
            }}
          >
            {t("gullak/accountDetailsWrong")}
          </Text>
          <Text
            onPress={async () => {
              this.props.navigation.navigate("AddBankDetails", {
                account_type: x.account_type,
                edit: true,
                data: x,
              });
            }}
            bold
            mukta
            fontType="head4"
            style={{ color: colors.primary }}
          >
            {t(`${PATH}/editAcc`)}
          </Text>
        </View>
      );
    }
  };

  renderMenuOptions = (index, x) => {
    const { openMenuIndex } = this.state;
    return (
      <View
        style={{
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Menu
          visible={openMenuIndex === index}
          onRequestClose={() => this.setState({ openMenuIndex: null })}
          anchor={
            <Pressable
              onPress={() => this.setState({ openMenuIndex: index })}
              style={{
                marginTop: verticalScale(10),
                justifyContent: "center",
                height: 30,
                width: 35,
                alignItems: "flex-end",
              }}
            >
              <SettingBlack />
            </Pressable>
          }
        >
          <MenuItem
            onPress={() => {
              this.setState({
                openMenuIndex: null,
                modalVisible: true,
                selectedItem: x,
              });
            }}
          >
            <View style={{ flexDirection: "row" }}>
              <DeleteIcon />
              <CustomText style={{ marginLeft: 5 }} variant="body_text_3">
                {t(`${PATH}/delete`)}
              </CustomText>
            </View>
          </MenuItem>
        </Menu>
      </View>
    );
  };

  renderMaskedAccountNumber = (value) => {
    return (
      value.substring(0, 2) +
      value.substring(2, value.length - 2).replace(/\d/g, "X") +
      value.substring(value.length - 2)
    );
  };

  renderBanks(banksList) {
    const {
      user: { phone_number = "", id = "", name = "" },
    } = this.props || {};
    const { activeIndex } = this.state;
    return (
      Array.isArray(banksList) &&
      banksList.map((x, i) => {
        console.log("banksList", x);
        const { account_number, user_name, is_blacklisted } = x;
        return (
          <View key={x.id}>
            <View style={styles.account_view}>
              {this.renderBlackListedBanks(x)}
              <View
                style={{
                  opacity: is_blacklisted ? 0.2 : 1,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                  }}
                >
                  <View
                    style={{
                      marginTop: verticalScale(10),
                      justifyContent: "center",
                    }}
                  >
                    <BankImage />
                  </View>

                  <Pressable
                    onPress={() =>
                      this.props.navigation.navigate("WithdrawFromAcc", {
                        item: x,
                        from: this.props.from,
                      })
                    }
                    style={{
                      flex: 1,
                      marginLeft: 12,
                    }}
                  >
                    <Text
                      mukta
                      semiBold
                      // fontType="head3"
                      style={[
                        styles.primaryHeading,
                        {
                          color: "black",
                          fontSize: 16,
                          marginBottom: 1,
                        },
                      ]}
                    >
                      {user_name}
                    </Text>
                    <Text
                      mukta
                      // fontType="head3"
                      style={[
                        styles.secondaryHeading,
                        {
                          color: "rgba(0, 0, 0, 0.56)",
                          fontSize: 14,
                        },
                      ]}
                    >
                      {this.renderMaskedAccountNumber(account_number)}
                    </Text>
                  </Pressable>

                  {this.renderMenuOptions(i, x)}
                </View>
                {/* this.renderEnterAmountView(x) */}
              </View>
            </View>
          </View>
        );
      })
    );
  }

  renderUpi(banksList) {
    const {
      user: { phone_number = "", id = "", name = "" },
    } = this.props || {};
    const { activeIndex } = this.state;
    return (
      Array.isArray(banksList) &&
      banksList.map((x, i) => {
        console.log("banksList", x);
        const {
          account_number,
          user_name,
          upi_address,
          is_blacklisted,
          account_type,
        } = x;
        return (
          <View key={x.id}>
            <View
              style={[
                styles.account_view,
                {
                  height:
                    activeIndex === x.id ? "auto" : is_blacklisted ? 106 : 78,
                },
              ]}
            >
              {this.renderBlackListedBanks(x)}
              <View
                style={{
                  opacity: is_blacklisted ? 0.2 : 1,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                  }}
                >
                  <View
                    style={{
                      marginTop: verticalScale(10),
                      justifyContent: "center",
                      alignItems: "center",
                      width: scale(30),
                      height: scale(30),
                      borderRadius: scale(15),
                      justifyContent: "center",
                      backgroundColor: colors.accountIcon,
                    }}
                  >
                    <Text bold style={{ fontSize: 14, color: "#fff" }}>
                      {user_name && typeof user_name === "string"
                        ? user_name.charAt(0).toUpperCase()
                        : upi_address.charAt(0).toUpperCase()}
                    </Text>
                  </View>

                  <Pressable
                    onPress={() =>
                      this.props.navigation.navigate("WithdrawFromAcc", {
                        item: x,
                        from: this.props.from,
                      })
                    }
                    style={{
                      flex: 1,
                      marginLeft: 12,
                    }}
                  >
                    <Text
                      mukta
                      semiBold
                      fontType="head3"
                      style={[
                        styles.primaryHeading,
                        {
                          color: "black",
                          fontSize: 16,
                          marginBottom: 2,
                        },
                      ]}
                    >
                      {user_name ?? upi_address}
                    </Text>
                    <Text
                      mukta
                      fontType="head3"
                      style={[
                        styles.secondaryHeading,
                        {
                          color: "rgba(0, 0, 0, 0.56)",
                          fontSize: 14,
                        },
                      ]}
                    >
                      {upi_address}
                    </Text>
                  </Pressable>
                  {this.renderMenuOptions(i, x)}
                </View>
                {this.renderEnterAmountView(x)}
              </View>
            </View>
          </View>
        );
      })
    );
  }

  renderJoinNewBank() {
    const {
      navigation,
      user: { phone_number = "", id = "", name = "" },
    } = this.props;

    return (
      <TouchableOpacity
        onPress={async () => {
          navigation.navigate("AddBankDetails");
        }}
        style={styles.add_new_account}
      >
        <Plus size={20} color={colors.primary} />
        <Text mukta fontType="head4" style={{ marginLeft: 8 }}>
          {t(`${PATH}/addNewBankAcc`)}
        </Text>
      </TouchableOpacity>
    );
  }

  renderUpiTransfer(upiAccounts) {
    const { activeIndex } = this.state;
    return (
      <>
        {Array.isArray(upiAccounts) &&
          upiAccounts.map((account, i) => {
            const { is_blacklisted } = account;
            return (
              <TouchableNativeFeedback
                key={account.id}
                background={TouchableNativeFeedback.Ripple(colors.mercury)}
                onPress={() => {
                  this.setActiveIndex(
                    activeIndex === account.id ? null : account.id,
                  );
                }}
              >
                <View
                  style={[
                    styles.account_view,
                    {
                      height:
                        activeIndex === account.id
                          ? "auto"
                          : is_blacklisted
                            ? 100
                            : 74,
                    },
                  ]}
                >
                  {this.renderBlackListedBanks(account)}
                  <View
                    style={{
                      flexDirection: "row",
                    }}
                  >
                    <Checkbox
                      checked={activeIndex === account.id}
                      checkedImage={require("../../assets/svg/WithdrawMoney/Checked.webp")}
                      uncheckedImage={require("../../assets/svg/WithdrawMoney/UnChecked.webp")}
                      onChange={() => {
                        this.setActiveIndex(
                          activeIndex === account.id ? null : account.id,
                        );
                      }}
                      containerStyle={{
                        marginRight: 8,
                      }}
                    />
                    <UPI />
                    <View
                      style={{
                        flex: 1,
                        marginLeft: 8,
                      }}
                    >
                      <Text
                        mukta
                        fontType="head4"
                        style={styles.primaryHeading}
                      >
                        {t(`${PATH}/yourReferral`, {
                          upi_address: account.upi_address,
                        })}
                      </Text>
                    </View>
                  </View>
                  {this.renderEnterAmountView(account)}
                </View>
              </TouchableNativeFeedback>
            );
          })}

        <TouchableNativeFeedback
          background={TouchableNativeFeedback.Ripple(colors.mercury)}
          onPress={() => {
            this.setActiveIndex(activeIndex === UPI_ID ? null : UPI_ID);
          }}
        >
          <View
            style={[
              styles.account_view,
              {
                height: activeIndex === UPI_ID ? "auto" : 56,
              },
            ]}
          >
            {/* {this.renderBlackListedBanks(account)} */}
            <View
              style={{
                flexDirection: "row",
              }}
            >
              <Checkbox
                checked={activeIndex === UPI_ID}
                checkedImage={require("../../assets/svg/WithdrawMoney/Checked.webp")}
                uncheckedImage={require("../../assets/svg/WithdrawMoney/UnChecked.webp")}
                onChange={() => {
                  this.setActiveIndex(activeIndex === UPI_ID ? null : UPI_ID);
                }}
                containerStyle={{
                  marginRight: 8,
                }}
              />
              <UPI />
              <View
                style={{
                  flex: 1,
                  marginLeft: 8,
                }}
              >
                <Text
                  onPress={() => this.props.navigation.navigate("AddNewUpi")}
                  mukta
                  fontType="head4"
                  style={styles.primaryHeading}
                >
                  {t(`${PATH}/transferOnUPIId`)}
                </Text>
              </View>
            </View>
            {this.renderEnterAmountView({
              id: UPI_ID,
              default_mode: "UPI",
              getUpiId: true,
            })}
          </View>
        </TouchableNativeFeedback>
      </>
    );
  }

  renderEmptyComponent = () => {
    return (
      <View
        style={{
          justifyContent: "center",
          alignItems: "center",
          marginTop: verticalScale(160),
        }}
      >
        <NoBank />
        <TouchableOpacity
          onPress={async () =>
            this.props.upiSelected
              ? this.props.navigation.navigate("AddNewUpi")
              : this.props.navigation.navigate("AddBankDetails")
          }
          style={styles.add_bank_button}
        >
          {!this.props.upiSelected && <Plus color={colors.white} />}
          <Text
            mukta
            fontType="head3"
            style={{ color: colors.white, marginLeft: 8 }}
          >
            {this.props.upiSelected
              ? t(`${PATH}/addUPIID`)
              : t(`${PATH}/addBankAcc`)}
          </Text>
        </TouchableOpacity>
      </View>
    );
  };

  render() {
    const { navigation, wallet } = this.props;
    let bankAccounts = [],
      upiAccounts = [];
    const {
      user: { phone_number = "", id = "", name = "" },
    } = this.props || {};

    if (wallet.fundAccountStatus === STATE_STATUS.FETCHED) {
      for (let i = 0; i < wallet.fundAccountsData.length; i++) {
        let account = wallet.fundAccountsData[i];
        if (account.account_type === ACCOUNT_TYPE.bank_account) {
          bankAccounts.push(account);
        }
        if (account.account_type === ACCOUNT_TYPE.vpa) {
          upiAccounts.push(account);
        }
      }
    }

    return (
      <View style={styles.container}>
        <ModalLoader
          loading={wallet.fundAccountStatus === STATE_STATUS.FETCHING}
        />
        <ConfirmDelete
          onYes={() => {
            const { account_number, upi_address } = this.state.selectedItem;
            const otpPayload = {};
            if (account_number) otpPayload.account_number = account_number;
            if (upi_address) otpPayload.upi_address = upi_address;
            getWalletOtp({ type: "delete", isDebug: __DEV__, ...otpPayload })
              .then((res) => {
                this.props.navigation.navigate("VerifyAccount", {
                  item: this.state.selectedItem,
                  type: "delete",
                });
              })
              .catch((err) => console.warn(err));
          }}
          closeModal={() => this.setState({ modalVisible: false })}
          modalVisible={this.state.modalVisible}
          message={
            this.props.bankSelected
              ? t("gullak/wantToDeleteAcc/bank")
              : t("gullak/wantToDeleteAcc/upi")
          }
        />
        <PaymentStatusModal
          status={wallet.withdrawAmountStatus}
          resetWithdrawMoney={async () => {
            this.props.resetWithdrawMoney();
            getAllWalletMetaData()
              .then(({ data }) => {
                const {
                  default: { toDate, fromDate },
                } = data.filters;
                this.props.setWalletMetaData(data);
                getWalletSummary({ to: toDate, from: fromDate }).then(
                  ({ data }) => {
                    this.props.setWalletSummary(data);
                  },
                );
              })
              .catch((e) => {
                console.log(e);
              });
          }}
        />
        <CustomText style={styles.primaryHeading} variant="body_text_2">
          {this.props.contentHeading}
        </CustomText>

        {wallet.fundAccountStatus === STATE_STATUS.FETCHED &&
        wallet.fundAccountsData.length > 0 ? (
          <CustomText
            style={[styles.secondaryHeading, { marginBottom: 24 }]}
            variant="caption_2"
          >
            {this.props.title}
          </CustomText>
        ) : (
          <CustomText
            style={[styles.secondaryHeading, { marginBottom: 24 }]}
            variant="caption_2"
          >
            {this.props.contentDesc}
          </CustomText>
        )}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 10,
          }}
        >
          <TabButton
            onPress={this.props.bankPress}
            title={t(`${PATH}/bankAcc`)}
            isSelected={this.props.bankSelected}
          />
          <TabButton
            onPress={this.props.upiPress}
            title="UPI ID"
            isSelected={this.props.upiSelected}
          />
        </View>

        {wallet.fundAccountStatus === STATE_STATUS.FETCHED &&
          wallet.fundAccountsData.length > 0 && (
            <>
              {this.props.bankSelected && this.renderBanks(bankAccounts)}
              {this.props.upiSelected && this.renderUpi(upiAccounts)}
            </>
          )}
        {wallet.fundAccountStatus === STATE_STATUS.FETCHED &&
          bankAccounts.length == 0 &&
          this.props.bankSelected &&
          this.renderEmptyComponent()}
        {wallet.fundAccountStatus === STATE_STATUS.FETCHED &&
          upiAccounts.length == 0 &&
          this.props.upiSelected &&
          this.renderEmptyComponent()}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingVertical: 18,
    height: "100%",
  },
  enter_amount_view: {
    marginTop: 12,
    // backgroundColor: "#f7f7f7",
    padding: 16,
    paddingVertical: 20,
    borderRadius: 6,
  },
  enter_amount_button: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 6,
    borderRadius: 6,
    paddingVertical: 14,
  },
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerContainer: {
    padding: 10,
  },
  primaryHeading: {
    // marginBottom: 12,
    marginBottom: 6,
  },
  secondaryHeading: {
    color: colors.lightBlack,
  },
  add_bank_button: {
    backgroundColor: colors.primary,
    height: verticalScale(54),
    width: "100%",
    marginVertical: 24,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: scale(10),
    flexDirection: "row",
  },
  add_new_account: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: colors.white,
    justifyContent: "flex-start",
    padding: 14,
    borderRadius: 6,
    elevation: 1,
    marginVertical: 4,
  },
  black_listed_view: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 8,
  },
  account_view: {
    flex: 1,
    overflow: "hidden",
    marginVertical: 4,
    overflow: "hidden",
    backgroundColor: colors.white,
    // elevation: 1,

    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,

    borderRadius: 6,
    padding: 16,
  },
});

const mstp = ({ wallet, auth: { user } }) => {
  return {
    wallet,
    user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFundAccounts: () => dispatch(walletActions.fetchFundAccounts()),
    createFundAccountBank: (payload) =>
      dispatch(walletActions.createFundAccountBank(payload)),
    createFundAccountVpa: (payload) =>
      dispatch(walletActions.createFundAccountVpa(payload)),
    withdrawMoney: (payload) => dispatch(walletActions.withdrawMoney(payload)),
    resetWithdrawMoney: () => dispatch(walletActions.resetWithdrawMoney()),
    resetFundAccountBank: () => dispatch(walletActions.resetFundAccountBank()),
    setWalletMetaData: (data) =>
      dispatch(walletActions.setWalletMetaData(data)),
    setWalletSummary: (data) => dispatch(walletActions.setWalletSummary(data)),
  };
};

export default connect(mstp, mapDispatchToProps)(WithdrawMoneyContent);
